import {Dispatch, SetStateAction, useState} from "react";
import {FiBellOff} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {TableCrownButton} from "@/components/tableCrownButton/TableCrownButton.tsx";
import {GlobalAlertState} from "@/lib/types/alerting.ts";
import {BulkIgnoreAlertsDialog} from "@/pages/alerting/components/list/actions/BulkIgnoreAlertsDialog.tsx";

interface AlertsBulkActionsBarProps {
  alerts: GlobalAlertState[];
  selectedItems: Record<string, boolean>;
  setSelectedItems: Dispatch<SetStateAction<Record<string, boolean>>>;
}

export const AlertsBulkActionsBar = ({alerts, selectedItems, setSelectedItems}: AlertsBulkActionsBarProps) => {
  const [showIgnore, setShowIgnore] = useState(false);
  const selectedAlerts = alerts.filter((alert) => selectedItems[String(alert.id)]);
  const disabled = selectedAlerts.length === 0;

  return (
    <>
      <TableCrownButton disabled={disabled} onClick={() => setShowIgnore(true)}>
        <Icon icon={FiBellOff} />
        Ignore
      </TableCrownButton>
      <BulkIgnoreAlertsDialog
        alerts={selectedAlerts}
        show={showIgnore}
        onClose={() => setShowIgnore(false)}
        onSuccess={() => setSelectedItems({})}
      />
    </>
  );
};
